import { render, staticRenderFns } from "./create_coupons.vue?vue&type=template&id=713605b3&scoped=true"
import script from "./create_coupons.vue?vue&type=script&lang=js"
export * from "./create_coupons.vue?vue&type=script&lang=js"
import style0 from "./create_coupons.vue?vue&type=style&index=0&id=713605b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713605b3",
  null
  
)

export default component.exports